import { h } from 'preact';
import { connect } from 'redux-zero/preact';

const mapToProps = ({message }) => ({message})

const NoParam = ({message}) => (
    <div className="et-container et-px-4 et-py-5 et-mx-auto">
        <div className="et-flex et-justify-center">
            <div className="et-w-1/2">
                <div className="neo-card et-rounded">
                    <div className="neo-card-body">
                        <h2 className="et-text-2xl et-text-center et-text-gray-700 et-font-bold">
                            {message || 'Invalid URL or token'}
                        </h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
)

export default connect(mapToProps,null)(NoParam)